import Rails from "@rails/ujs"
import { Controller } from "stimulus"
import { showOverlay, hideOverlay, scrollToFirstError, buildValidationFormData, postValidation, failureMessage } from '../services/form_helper'

export default class extends Controller {
  static targets = ['form','insuranceCardFieldRead','insuranceCardFieldWrite','insuranceCardRegister','frontImage','backImage','add1Image','add2Image'];
  static classes = ['errorm','hide'];
  static values = {validateurl: String, validateflag: String, uploadurl: String, removeimageurl: String, networkErrorMessage: String};
  formTargetConnected() {
    this.toggleInsuranceCardInput();
    super.connect();
  }

  validate(event){
    const el = event.currentTarget;
    const pa = el.parentElement;
    const params = event.params;
    let errorM = pa.querySelector("."+this.errormClass);
    if(errorM == undefined){
      errorM = pa.parentElement.querySelector("."+this.errormClass);
      if(errorM == undefined){
        errorM = pa.parentElement.parentElement.querySelector("."+this.errormClass);
      }
    }
    // YAS-31 FR-2: 実ファイルではなく1バイトの代理ファイルを送る（空body送信の回避）
    const formData = buildValidationFormData(this.formTarget);
    formData.append("type",params.column);
    Rails.ajax({
      url: this.validateurlValue,
      type: "POST",
      dataType: 'json',
      data: formData,
      success: (response)=> {
        errorM.innerHTML = response;
      }
    });
  }

  validateAll(event){
    const el = event.currentTarget;
    showOverlay();
    el.disabled = true;
    let errorMs = document.querySelectorAll("."+this.errormClass);
    errorMs.forEach(function (m) {
      m.textContent = "";
    });
    const allErrorE = document.getElementById("allError");
    // YAS-31 FR-3: 旧実装は error コールバックが無く、検証AJAX が失敗すると
    // オーバーレイ表示・ボタン無効のまま完全に固着していた（＝「予約できない」問い合わせ）。
    postValidation({
      url: this.validateurlValue,
      buildFormData: () => buildValidationFormData(this.formTarget),
      onSuccess: (response)=> {
        if(Object.keys(response).length > 0){
          let allErrorTxt = "";
          Object.keys(response).forEach(function (key) {
            errorMs.forEach(function (m) {
              if (m.dataset.errormtarget == key){
                m.innerHTML = response[key];
                allErrorTxt += response[key]+"<br />";
              }
            })
          });
          allErrorE.innerHTML = allErrorTxt;
          allErrorE.classList.remove(this.hideClass);
          hideOverlay();
          el.disabled = false;
          scrollToFirstError(this.errormClass);
        }else{
          allErrorE.innerHTML = '';
          allErrorE.classList.add(this.hideClass);
          this.formTarget.submit();
        }
      },
      onFailure: (response)=> {
        // 入力値・添付は消さずに残し、ユーザーがそのまま再試行できる状態へ戻す
        allErrorE.innerHTML = failureMessage(response, this.networkErrorMessageValue);
        allErrorE.classList.remove(this.hideClass);
        hideOverlay();
        el.disabled = false;
      }
    });
  }

  toggleInsuranceCardInput(){
    const form = this.formTarget
    const discard_field = form.querySelector("input[name='insurance_card[discard]']")

    if (discard_field != null){
        this.insuranceCardRegisterTarget.classList.remove('is-hidden')
        discard_field.value = false
    }
  }

}
